import { ReactNode } from "react";
import { useRecoilState } from "recoil";
import { currentCenterModalState } from "store/recoil/@common/centerModalState";
import { useOnClickOutside } from "hooks/useOnClickOutside";
import styles from "./CenterModalOverlay.module.scss";

interface IProps {
  children: ReactNode;
}
export default function CenterModalOverlay({ children }: IProps) {
  const [isOpenCenterModal, setIsOpenCenterModal] = useRecoilState(currentCenterModalState);

  const outSideRef = useOnClickOutside(() => {
    setIsOpenCenterModal(false);
  });

  return (
    <>
      <section className={styles.overlay} />
      <section ref={outSideRef} className={styles.modalWrapper} data-active={isOpenCenterModal}>
        <div className={styles.content}>{children}</div>
      </section>
    </>
  );
}
